import { YouTubeVideoId } from '@customer/config/videos';
import PaywallPage from '@customer/templates/paywall-page/PaywallPage';
import { useTranslation } from 'react-i18next';

export function PerformancePaywall() {
  const { t } = useTranslation();

  return (
    <PaywallPage
      title={t('PerformancePaywallTitle')}
      subtitle={t('PerformancePaywallSubtitle')}
      description={t('PerformancePaywallDescription')}
      videoProps={{
        videoId: YouTubeVideoId.FleetPerformance,
        title: t('PerformancePaywallVideoTitle'),
      }}
    />
  );
}

export default PerformancePaywall;
